import { ROOT_URL } from '@/utils/settings'

export const isProduction = () => {
  if (!ROOT_URL) return false

  try {
    const url = new URL(ROOT_URL)
    return url.hostname === 'machicon.jp' || url.hostname === 'www.machicon.jp'
  } catch {
    return false
  }
}

export const isStaging = () => {
  if (!ROOT_URL) return false

  try {
    const url = new URL(ROOT_URL)
    return url.hostname === 'stg-pwa.machicon.jp'
  } catch {
    return false
  }
}

export const isFeature = () => {
  if (!ROOT_URL) return false

  try {
    const url = new URL(ROOT_URL)
    // feature01.machicon.jp　~ feature07.machicon.jp など
    return /^feature\d+\.machicon\.jp$/.test(url.hostname)
  } catch {
    return false
  }
}

export const isLocalhost = () => {
  if (!ROOT_URL) return false

  try {
    const url = new URL(ROOT_URL)
    return url.hostname === 'localhost' || url.hostname === '127.0.0.1' || url.hostname === '::1'
  } catch {
    return false
  }
}
